import {Badge, Box, Flex, Menu} from "@contentful/f36-components";
import React from "react";
import {useSDK} from "@contentful/react-apps-toolkit";
import {getVariantFromStatus} from "../../utils";
import {cancelOrders} from "../../services/translated";

export const SidebarTranslationOrdersListItem = ({ order, isLast }) => {
    const sdk = useSDK();

    const { numberOfLanguages } = order;

    const onDetailsOpen = async () => {
        await sdk.dialogs.openCurrentApp({
            title: 'Order details',
            shouldCloseOnOverlayClick: true,
            parameters: {
                type: 'order-details',
                order
            },
            width: 520,
        });
    }

    const onCancelOrder = async () => {
        await sdk.dialogs.openConfirm({
            title: `Cancel order ${order.id}?`,
            message: 'The action is irreversible and your content will not be translated. You will not be charged for this order.',
            intent: 'negative',
            confirmLabel: 'Yes, cancel',
            cancelLabel: 'No'
        }).then(cancelOrder);
    }

    const cancelOrder = async () => {
        try {
            const undeletedOrders = await cancelOrders({
                apiKey: sdk.parameters.installation.apiKey,
                orders: order.id_requests,
            });
            if (undeletedOrders.orders.length > 0) {
                sdk.notifier.warning('Warning: not all orders could be deleted! Undeleted orders: ' + undeletedOrders.orders.join(', '));
            } else {
                sdk.notifier.success('Order cancelled successfully.');
            }
        } catch (e) {
            sdk.notifier.error(e.response?.data ?? e.message);
        }
    }

    return (
        <Box paddingTop="spacingS" paddingBottom={`${isLast ? '' : 'spacingXs'}`} className={`${isLast ? '' : 'border-b-gray'}`}>
            <Flex justifyContent="space-between">
                <Flex flexDirection="column" className="max-w-140">
                    <strong>{order.id}</strong>
                    <span>{numberOfLanguages} language{numberOfLanguages > 1 ? 's' : ''}</span>
                </Flex>
                <Badge variant={getVariantFromStatus(order.status)}>{order.status}</Badge>
                <Menu placement={"right-start"}>
                    <Menu.Trigger>
                        <div className="pointer">...</div>
                    </Menu.Trigger>
                    <Menu.List>
                        <Menu.Item onClick={onDetailsOpen}>Details</Menu.Item>
                        <Menu.Item as="a" onClick={() => {
                            window.open(`mailto:${process.env.REACT_APP_EMAIL_ADDRESS}`);
                        }}>
                            Contact us
                        </Menu.Item>
                        <Menu.SectionTitle>{order.status?.toUpperCase()}</Menu.SectionTitle>
                        {order.status === 'IN QUEUE' && <Menu.Item onClick={onCancelOrder}>Cancel order</Menu.Item>}
                    </Menu.List>
                </Menu>
            </Flex>
        </Box>
    );
}